<template>
    <div>
        <modal :show.sync="addProduct" headerClasses="justify-content-center">
            <h6 slot="header" class="title title-up">Agregar inmueble</h6>
                <div class="form-group">
                    <label>Lote/Cultivo *</label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="lote o cultivo"
                                placeholder="lote o cultivo"
                                autocomplete="off"
                                v-validate="modelValidations.estateLot"
                                :error="getError('lote o cultivo')"
                                v-model="estateLot">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Cantidad *</label>
                    <fg-input   tabindex="2"
                                type="text"
                                name="cantidad"
                                placeholder="cantidad"
                                autocomplete="off"
                                v-validate="modelValidations.estateQty"
                                :error="getError('cantidad')"
                                v-model="estateQty">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Superficie/Densidad de siembra </label>
                    <fg-input   tabindex="3"
                                type="text"
                                name="superficie"
                                placeholder="superficie"
                                autocomplete="off"
                                v-validate="modelValidations.estateSurface"
                                :error="getError('superficie')"
                                v-model="estateSurface">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Tipo propiedad terreno *</label>
                    <fg-input   tabindex="4"
                                name="tipo propiedad terreno"
                                v-validate="modelValidations.estatePropertyType"
                                :error="getError('tipo propiedad terreno')"
                                v-model="estatePropertyType">
                            <el-select
                                    class="select-warning"
                                    size="large"
                                    placeholder="Seleccione..."
                                    v-model="estatePropertyType">
                            <el-option
                                    class="select-warning"
                                    value="PROPIA"
                                    label="PROPIA">
                            </el-option>
                            <el-option
                                    class="select-warning"
                                    value="ARRENDADA"
                                    label="ARRENDADA">
                            </el-option>
                            <el-option
                                    class="select-warning"
                                    value="FAMILIAR"
                                    label="FAMILIAR">
                            </el-option>
                        </el-select>
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Edad de cultivo </label>
                    <fg-input   tabindex="5"
                                type="text"
                                name="edad de cultivo"
                                placeholder="edad de cultivo"
                                autocomplete="off"
                                v-validate="modelValidations.estateAge"
                                :error="getError('edad de cultivo')"
                                v-model="estateAge">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Variedad </label>
                    <fg-input   tabindex="6"
                                type="text"
                                name="variedad"
                                placeholder="variedad"
                                autocomplete="off"
                                v-validate="modelValidations.estateVariety"
                                :error="getError('variedad')"
                                v-model="estateVariety">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Riego </label>
                    <fg-input   tabindex="7"
                                name="riego"
                                v-validate="modelValidations.estateIrrigation"
                                :error="getError('riego')"
                                v-model="estateIrrigation">
                            <el-select
                                    class="select-warning"
                                    size="large"
                                    placeholder="Seleccione..."
                                    v-model="estateIrrigation">
                            <el-option
                                    class="select-warning"
                                    value="SI"
                                    label="SI">
                            </el-option>
                            <el-option
                                    class="select-warning"
                                    value="NO"
                                    label="NO">
                            </el-option>
                        </el-select>
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Valoración *</label>
                    <vue-numeric  :max=999999999 tabindex="8" currency="$" autocomplete="off" name="valoración" v-validate="modelValidations.estateValue" :error="getError('valoración')" separator="." class="form-control" v-model="estateValue"></vue-numeric>
                    <span v-show="errors.has('valoración')" class="text-danger" style="font-size: 11px;">
                        {{ errors.first('valoración') }}
                    </span>
                </div>
            <template slot="footer">
                <div class="left-side">
                <p-button type="default" link @click="cancelAddProduct()">Cancelar</p-button>
                </div>
                <div class="divider"></div>
                <div class="right-side">
                <p-button type="default" link @click="addProductToList()">Agregar</p-button>
                </div>
            </template>
        </modal>
        <modal :show.sync="editProduct" headerClasses="justify-content-center">
            <h6 slot="header" class="title title-up">Editar inmueble</h6>
            <div class="form-group">
                    <label>Lote/Cultivo *</label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="lote o cultivo"
                                placeholder="lote o cultivo"
                                autocomplete="off"
                                v-validate="modelValidations.estateLot"
                                :error="getError('lote o cultivo')"
                                v-model="estateLot">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Cantidad *</label>
                    <fg-input   tabindex="2"
                                type="text"
                                name="cantidad"
                                placeholder="cantidad"
                                autocomplete="off"
                                v-validate="modelValidations.estateQty"
                                :error="getError('cantidad')"
                                v-model="estateQty">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Superficie/Densidad de siembra </label>
                    <fg-input   tabindex="3"
                                type="text"
                                name="superficie"
                                placeholder="superficie"
                                autocomplete="off"
                                v-validate="modelValidations.estateSurface"
                                :error="getError('superficie')"
                                v-model="estateSurface">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Tipo propiedad terreno *</label>
                    <fg-input   tabindex="4"
                                name="propiedad"
                                v-validate="modelValidations.estatePropertyType"
                                :error="getError('propiedad')"
                                v-model="estatePropertyType">
                            <el-select
                                    class="select-warning"
                                    size="large"
                                    placeholder="Seleccione..."
                                    v-model="estatePropertyType">
                            <el-option
                                    class="select-warning"
                                    value="PROPIA"
                                    label="PROPIA">
                            </el-option>
                            <el-option
                                    class="select-warning"
                                    value="ARRENDADA"
                                    label="ARRENDADA">
                            </el-option>
                            <el-option
                                    class="select-warning"
                                    value="FAMILIAR"
                                    label="FAMILIAR">
                            </el-option>
                        </el-select>
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Edad de cultivo </label>
                    <fg-input   tabindex="5"
                                type="text"
                                name="edad de cultivo"
                                placeholder="edad de cultivo"
                                autocomplete="off"
                                v-validate="modelValidations.estateAge"
                                :error="getError('edad de cultivo')"
                                v-model="estateAge">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Variedad </label>
                    <fg-input   tabindex="6"
                                type="text"
                                name="variedad"
                                placeholder="variedad"
                                autocomplete="off"
                                v-validate="modelValidations.estateVariety"
                                :error="getError('variedad')"
                                v-model="estateVariety">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Riego </label>
                    <fg-input   tabindex="7"
                                name="riego"
                                v-validate="modelValidations.estateIrrigation"
                                :error="getError('riego')"
                                v-model="estateIrrigation">
                            <el-select
                                    class="select-warning"
                                    size="large"
                                    placeholder="Seleccione..."
                                    v-model="estateIrrigation">
                            <el-option
                                    class="select-warning"
                                    value="SI"
                                    label="SI">
                            </el-option>
                            <el-option
                                    class="select-warning"
                                    value="NO"
                                    label="NO">
                            </el-option>
                        </el-select>
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Valoración *</label>
                    <vue-numeric  :max=999999999 tabindex="8" currency="$" autocomplete="off" name="valoración" v-validate="modelValidations.estateValue" :error="getError('valoración')" separator="." class="form-control" v-model="estateValue"></vue-numeric>
                    <span v-show="errors.has('valoración')" class="text-danger" style="font-size: 11px;">
                        {{ errors.first('valoración') }}
                    </span>
                </div>
            <template slot="footer">
                <div class="left-side">
                <p-button type="default" link @click="cancelEditProduct()">Cancelar</p-button>
                </div>
                <div class="divider"></div>
                <div class="right-side">
                <p-button type="default" link @click="editProductToList()">Editar</p-button>
                </div>
            </template>
        </modal>
        <div class="col-md-12 mb-2">
                <h4 class="title center-title">Hoja de trabajo</h4>
        </div>
        <!-- Inventory -->
        <card  class="form-horizontal">
            <div class="card-header">
                <h6 class="card-title">Inmuebles</h6>
            </div>
            <div class="card-body">
                <el-table v-if="products.length" :data="products"  ref="productsTable"  highlight-current-row @current-change="handleCurrentChange">
                    <el-table-column type="expand">
                        <template slot-scope="props">
                            <p>Lote:{{ props.row.estateLot }}</p>
                            <p>Cantidad: {{ props.row.estateQty }}</p>
                            <p>Superficie/Densidad de siembra: {{ props.row.estateSurface }}</p>
                            <p>Tipo propiedad terreno: {{ props.row.estatePropertyType }}</p>
                            <p>Edad de cultivo: {{ props.row.estateAge }}</p>
                            <p>Variedad: {{ props.row.estateVariety }}</p>
                            <p>Riego: {{ props.row.estateIrrigation }}</p>
                            <p>Valoración: {{ setFormat(props.row.estateValue) }}</p>
                        </template>
                    </el-table-column>
                    <el-table-column label="Lote/Cultivo" property="estateLot"></el-table-column>
                    <el-table-column label="Total">
                        <template slot-scope="scope">
                            <span >{{ setFormat(scope.row.estateValue )}}</span>
                        </template>
                    </el-table-column>
                </el-table>
                
                <div>
                    <p-button 
                        v-if="products.length < 5"
                        @click="addProductMethod()"
                        type="default" 
                        >
                        <i class="mr-2 fa fa-plus"></i>Agregar inmueble
                    </p-button>
                    <br>
                    <p-button v-if="currentRow"
                        @click="editProductMethod()"
                        type="default" 
                        >
                        <i class="mr-2 fa fa-pencil"></i>Editar inmueble
                    </p-button>
                    <br>
                    <p-button v-if="currentRow"
                        @click="removeProductMethod()"
                        type="default" 
                        >
                        <i class="mr-2 fa fa-minus"></i>Quitar inmueble
                    </p-button>
                </div>
            </div>
            <div class="card-footer">
                <div v-if="totalEstate != 0" class="alert alert-warning mt-2">
                    <span>Valor total inmuebles: {{ setFormat(totalEstate)}}</span>
                </div>
            </div>
        </card>
        <div class="text-right">
            <p-button @click="saveEstate()" type="warning">Siguiente</p-button>
            <p-button @click="toMenu()" type="default" class="pull-left mb-3">Atrás</p-button>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue'
    import swal from 'sweetalert2'
    import { Card, Collapse, CollapseItem, Modal } from 'src/components/UIComponents'
    import PSwitch from 'src/components/UIComponents/Switch.vue'
    import VueNumeric from 'vue-numeric'
    import formatMoney from 'accounting-js/lib/formatMoney.js'
    import {Select, Option, Table, TableColumn} from 'element-ui'
    import Expenses from 'src/util/Others/OperatingExpenses'
    import Taxes from 'src/util/Services/Taxes'
    import moment from 'moment'
    Vue.use(Select)
    Vue.use(Option)
    Vue.use(Table)
    Vue.use(TableColumn)
    export default {
        components: {
            Card,
            PSwitch,
            VueNumeric,
            Collapse,
            CollapseItem,
            Modal
        },
        data() {
        return {
            form: {
                average_selection: '',
            },
            operatingSwitches: {
                expenses: false,
                inventory: false,
            },
            microcredit: false,
            consumer: false,
            pyme: false,
            expenses : [],
            actualExpenses: [],
            currentRow: null,
            addExpense: false,
            editExpense: false,
            addExpenseIndex: null,
            addProduct: false,
            editProduct: false,
            addProductIndex: null,
            monthlyNumber: '',
            expenseName: '',
            expenseValue: '',
            expenseLocked: false,
            productName: '',
            productQuantity: '',
            productCostUnity: '',
            productSaleUnity: '',
            productCostTotal: '',
            productMonthlyCost: '',
            inventoryName: '',
            inventoryQty: '',
            inventoryValue: '',
            inventoryTotal: '',
            estateLot: '',
            estateQty: '',
            estateSurface: '',
            estatePropertyType: '',
            estateAge: '',
            estateVariety: '',
            estateIrrigation: '',
            estateValue: '',
            referenceDescription: '',
            products: [
                
            ],
            costs: [],
            average: {
                good_sale: '',
                bad_sale: '',
                regular_sale: '',
                average_sales: '',
                monthly_average_sales: ''
            },
            modelValidations: {
                estateLot: {
                    required: true,
                    max: 20,
                    regex: /^[a-zA-ZáéíóúÁÉÍÓÚñÑ0-9 ]*$/
                },
                estateQty: {
                    required: true,
                    max: 20,
                    regex: /^[a-zA-ZáéíóúÁÉÍÓÚñÑ0-9 ]*$/
                },
                estateSurface: {
                    required: false,
                    max: 20,
                    regex: /^[a-zA-ZáéíóúÁÉÍÓÚñÑ0-9 ]*$/
                },
                estatePropertyType: {
                    required: true
                },
                estateAge: {
                    required: false,
                    max: 20,
                    regex: /^[a-zA-ZáéíóúÁÉÍÓÚñÑ0-9 ]*$/
                },
                estateVariety: {
                    required: false,
                    max: 20,
                    regex: /^[a-zA-ZáéíóúÁÉÍÓÚñÑ0-9 ]*$/
                },
                estateIrrigation: {
                    required: false,
                    max: 20,
                    regex: /^[a-zA-ZáéíóúÁÉÍÓÚñÑ0-9 ]*$/
                },
                estateValue: {
                    required: true,
                    max: 20
                }
            },
        }
        },
        watch: {
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            'operatingSwitches.expenses': function (newVal, oldVal) {
                if (!newVal) {
                    this.actualExpenses = [];
                    for (let i=0; i<this.expenses.length;i++) {
                        this.actualExpenses.push({
                            id: this.expenses[i].id,
                            name: this.expenses[i].name,
                            value: 0,
                            locked: true
                        })
                    }
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            'operatingSwitches.inventory': function (newVal, oldVal) {
                if (!newVal) {
                    this.products = []
                }
            },
        },
        computed: {
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            verifyNext () {
                if (!this.operatingSwitches.expenses && !this.operatingSwitches.inventory) {
                    return true
                }
                else if(this.operatingSwitches.expenses && this.operatingSwitches.inventory &&  this.allExpensesMonthlyCostComputed != 0 && this.totalEstate != 0) {
                    return true
                }
                else if(this.operatingSwitches.expenses  &&  this.allExpensesMonthlyCostComputed ) {
                    if(!this.operatingSwitches.inventory) {
                        return true
                    }
                }
                else if(this.operatingSwitches.inventory  &&  this.totalEstate ) {
                    if(!this.operatingSwitches.expenses) {
                        return true
                    }
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            productCostTotalComputed() {
                var total = this.productQuantity * this.productSaleUnity;
                this.productCostTotal = total;
                return total;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            totalEstate() {
                var sum = 0;
                for (let i = 0;i<this.products.length;i++) {
                    sum = sum + this.products[i].estateValue; 
                }
                return sum
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             totalExtension() {
                return this.products.reduce((total, product) => {
                    // Extraer solo los números de estateQty
                    let qty = parseInt(product.estateQty.replace(/\D/g, ''), 10);
                    // Si qty no es un número válido, se asume como 0
                    return total + (isNaN(qty) ? 0 : qty);
                }, 0);
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            productMonthlyCostComputed() {
                var total = 0;
                if (this.monthlyNumber != '') {
                    var total = this.productQuantity * this.productCostUnity * this.monthlyNumber;
                    this.productMonthlyCost = total;
                }
                return total;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            allExpensesMonthlyCostComputed() {
                var sum = 0;
                for (let i=0;i<this.actualExpenses.length;i++) {
                    sum = sum + (this.actualExpenses[i].value);
                }
                return sum   
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            allCostsComputed() {
                return this.allExpensesMonthlyCostComputed
            }
        },
        methods: {
            toMenu () {
                this.$router.push('/asessments/menu');
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            productValidator (product) {
                if (this.$store.state.isCustomer) {
                    if (product.name.toLowerCase() == 'consumo') {
                        this.consumer = true;
                        this.microcredit = false;
                        if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].references.length != 0) {
                            this.products = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].references;
                            
                        }
                    }
                    else if (product.name.toLowerCase() == 'microcrédito' || product.name.toLowerCase() == 'microcredito') {
                        this.microcredit = true;
                        this.consumer = false;
                        if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].costsPopulate && this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].references.length != 0) {
                            this.products = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].references;
                            
                        }
                    }
                    else if (product.name.toLowerCase() == 'pequeña empresa') {
                        this.microcredit = false;
                        this.consumer = false;
                        this.pyme = true;
                        if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].costsPopulate && this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].references.length != 0) {
                            this.products = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].references;
                            
                        }
                    }
                    
                }
                else if(this.$store.state.isSpouse) {
                    if (product.name.toLowerCase() == 'consumo') {
                        this.consumer = true;
                        this.microcredit = false;
                        if (this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].references.length != 0) {
                            this.products = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].references;
                            
                        }
                    }
                    else if (product.name.toLowerCase() == 'microcrédito' || product.name.toLowerCase() == 'microcredito') {
                        this.microcredit = true;
                        this.consumer = false;
                        if (this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].costsPopulate && this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].references.length != 0) {
                            this.products = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].references;
                            
                        }
                    }
                    else if (product.name.toLowerCase() == 'pequeña empresa') {
                        this.microcredit = false;
                        this.consumer = false;
                        this.pyme = true;
                        if (this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].costsPopulate && this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].references.length != 0) {
                            this.products = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].references;
                            
                        }
                    }
                    
                }
                if (this.$store.state.isGuarantor) {
                    if (product.name.toLowerCase() == 'consumo') {
                        this.consumer = true;
                        this.microcredit = false;
                        if (this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].references.length != 0) {
                            this.products = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].references;
                            
                        }
                    }
                    else if (product.name.toLowerCase() == 'microcrédito' || product.name.toLowerCase() == 'microcredito') {
                        this.microcredit = true;
                        this.consumer = false;
                        if (this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].costsPopulate && this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].references.length != 0) {
                            this.products = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].references;
                            
                        }
                    }
                    else if (product.name.toLowerCase() == 'pequeña empresa') {
                        this.microcredit = false;
                        this.consumer = false;
                        this.pyme = false;
                        if (this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].costsPopulate && this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].references.length != 0) {
                            this.products = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].references;
                            
                        }
                    }
                    
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            handleCurrentChange(currentRow, oldCurrentRow) {
                this.currentRow = currentRow;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            editExpenseToList () {
                if (this.expenseName == '') {
                    this.showNotificationError('El campo nombre de gasto no puede estar vacío');
                }
                else {
                    var index = this.actualExpenses.indexOf(this.currentRow);
                    this.actualExpenses[index].name = this.expenseName;
                    this.actualExpenses[index].value = this.expenseValue;
                    this.resetExpense();
                    this.currentRow = null;
                    this.$refs.expensesTable.setCurrentRow();
                    this.editExpense = false;
                    this.showNotificationSuccess('Gasto editado correctamente');
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            addExpenseMethod (row) {
                // this.addProductIndex = row;
                this.addExpense = true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            handleCurrentChange(currentRow, oldCurrentRow) {
                this.currentRow = currentRow;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            addProductToList () {
                this.$validator.validateAll().then(isValid => {
                    if(isValid){
                        this.products.push({
                            estateLot: this.estateLot,
                            estateQty: this.estateQty,
                            estateSurface: this.estateSurface,
                            estatePropertyType: this.estatePropertyType,
                            estateAge: this.estateAge,
                            estateVariety: this.estateVariety,
                            estateIrrigation: this.estateIrrigation,
                            estateValue: parseFloat(this.estateValue) || 0,
                        })
                        this.resetProduct();
                        this.addProduct = false;
                        this.errors.clear();
                        this.showNotificationSuccess('Inmueble agregado correctamente');
                        }
                        else {
                            console.error('Error: Campos no diligenciados correctamente');
                            console.log('Errores de validación:', this.errors.items); // Muestra los errores específicos
                            this.errors.items.forEach(error => {
                                console.log(`Campo: ${error.field}, Mensaje: ${error.msg}`);
                            });
                            this.showNotificationError('Campos no diligenciados correctamente');
                        }
                })

            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            resetProduct () {
                this.estateLot = '';
                this.estateQty = '';
                this.estateSurface = '';
                this.estatePropertyType = '';
                this.estateAge = '';
                this.estateVariety = '';
                this.estateIrrigation = '';
                this.estateValue = '';
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            editProductMethod () {
                this.estateLot =  this.currentRow.estateLot;
                this.estateQty =  this.currentRow.estateQty;
                this.estateSurface =  this.currentRow.estateSurface;
                this.estatePropertyType =  this.currentRow.estatePropertyType;
                this.estateAge =  this.currentRow.estateAge;
                this.estateVariety =  this.currentRow.estateVariety;
                this.estateIrrigation =  this.currentRow.estateIrrigation;
                this.estateValue =  this.currentRow.estateValue;
                this.editProduct = true;  
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            removeProductMethod () {
                this.products.splice(this.products.indexOf(this.currentRow),1);
                this.currentRow = null;
                this.resetProduct();
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            editProductToList () {
                this.$validator.validateAll().then(isValid => {
                    if(isValid){
                            var index = this.products.indexOf(this.currentRow);
                            this.products[index].estateLot = this.estateLot;
                            this.products[index].estateQty = this.estateQty;
                            this.products[index].estateSurface = this.estateSurface;
                            this.products[index].estatePropertyType = this.estatePropertyType;
                            this.products[index].estateAge = this.estateAge;
                            this.products[index].estateVariety = this.estateVariety;
                            this.products[index].estateIrrigation = this.estateIrrigation;
                            this.products[index].estateValue = parseFloat(this.estateValue) || 0;
                            this.resetProduct();
                            this.currentRow = null;
                            this.$refs.productsTable.setCurrentRow();
                            this.editProduct = false;
                            this.errors.clear();
                            this.showNotificationSuccess('Inmueble editado correctamente');
                        }
                        else {
                            console.error('Error: Campos no diligenciados correctamente');
                            console.log('Errores de validación:', this.errors.items); // Muestra los errores específicos
                            this.errors.items.forEach(error => {
                                console.log(`Campo: ${error.field}, Mensaje: ${error.msg}`);
                            });
                            this.showNotificationError('Campos no diligenciados correctamente');
                        }
                })
                
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            addProductMethod (row) {
                this.addProductIndex = row;
                this.errors.clear();
                this.addProduct = true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            cancelAddProduct () {
                this.addProduct = false;
                this.errors.clear();
                this.resetItem();
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            cancelEditProduct () {
                this.editProduct = false;
                this.errors.clear();
                this.resetItem();
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            resetItem () {
                this.itemName = '';
                this.itemPurchasePrice = '';
                this.itemSalePrice = '';
                this.itemPercent = '';
                this.productName= '';
                this.productQuantity= '';
                this.productCostUnity= '';
                this.productSaleUnity= '';
                this.productCostTotal= '';
                this.productMonthlyCost= '';
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            showNotificationError (message) {
                this.$notify(
                {
                    message: message,
                    icon: 'nc-icon nc-glasses-2',
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: 'danger'
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            showNotificationSuccess (message) {
                this.$notify(
                {
                    message: message,
                    icon: 'nc-icon nc-check-2',
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: 'success'
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            addExpenseToList () {
                if (this.expenseName == '') {
                    this.showNotificationError('El campo nombre de gasto no puede estar vacío');
                }
                else {
                    var id = this.actualExpenses.length + 1;
                    this.actualExpenses.push({
                        id: id,
                        name: this.expenseName,
                        value: this.expenseValue,
                        locked: false
                    })
                    this.resetExpense();
                    this.addExpense = false;
                    this.showNotificationSuccess('Gasto agregado correctamente');
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            resetExpense () {
                this.expenseName = '';
                this.expenseValue = '';   
                this.expenseLocked = false;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            addProductMethod () {
                this.addProduct = true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            editExpenseMethod () {
                this.expenseName= this.currentRow.name;
                this.expenseValue= this.currentRow.value;
                this.expenseLocked = this.currentRow.locked;
                this.editExpense = true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            removeExpenseMethod () {
                this.actualExpenses.splice(this.actualExpenses.indexOf(this.currentRow),1);
                this.currentRow = null;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            cancelAddExpense () {
                this.addExpense = false;
                this.resetExpense();
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            cancelEditExpense () {
                this.editExpense = false;
                this.resetExpense();
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            setFormat (value) {
                return formatMoney(value, { symbol: "$", precision: 0, thousand: ".", decimal: "," });
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            getError (fieldName) {
                return this.errors.first(fieldName)
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            toSalesCostsSelection () {
                this.$router.push('/asessments/new_asessment/customer/sales_costs_selection');
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            toOperatingExpenses () {
                this.$router.push('/asessments/new_asessment/customer/others/operating_expenses');
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            toRequestData () {
                this.$router.push('/asessments/new_asessment/customer/request_data');
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            saveEstate () {
                if (this.products.length != 0) {
                    const payload = {
                        products: this.products,
                        totalEstate: this.totalEstate,
                        totalExtension: this.totalExtension
                    };
                    this.$store.dispatch('setAgroEstate', payload).then(()=>{
                        var vm = this;
                        const routes = [
                            {
                                title: '¿Deseas agregar Instalaciones / Otros Activos Agropecuarios?',
                                text: 'Si aceptas, podrás agregar o editar la información de Construcciones desmontables / Herramientas / Maquinaria y Equipo',
                                route: '/asessments/new_asessment/customer/agro/machinery'
                            },
                            {
                                title: '¿Deseas agregar Rendimientos históricos?',
                                text: 'Si aceptas, podrás agregar o editar la información de cultivos a cosechar durante el ciclo a financiar',
                                route: '/asessments/new_asessment/customer/agro/historical_yields'
                            },
                            {
                                title: '¿Deseas agregar Ingresos por ventas de productos almacenados?',
                                text: 'Si aceptas, podrás agregar o editar la información de Agrícolas / Pecuarios / Animales durante el ciclo a financiar',
                                route: '/asessments/new_asessment/customer/agro/product'
                            },
                            {
                                title: '¿Deseas agregar Ingresos por ventas estacionales?',
                                text: 'Si aceptas, podrás agregar o editar la información de Ingresos por ventas estacionales',
                                route: '/asessments/new_asessment/customer/agro/seasonal_sales'
                            },
                            {
                                title: '¿Deseas agregar Ingresos por jornales o salarios a la actividad agropecuaria?',
                                text: 'Si aceptas, podrás agregar o editar la información de Ingresos por jornales o salarios a la actividad agropecuaria',
                                route: '/asessments/new_asessment/customer/agro/salary'
                            }
                        ];
                        let currentIndex = 0;
                        function askRoute() {
                            if (currentIndex < routes.length) {
                                const current = routes[currentIndex];
                                swal({
                                    title: current.title,
                                    text: current.text,
                                    type: 'info',
                                    showCancelButton: true,
                                    confirmButtonText: 'Si, aceptar',
                                    cancelButtonText: 'No, continuar',
                                    confirmButtonClass: 'btn btn-success btn-fill',
                                    cancelButtonClass: 'btn btn-danger btn-fill',
                                    buttonsStyling: false
                                }).then(() => {
                                    vm.$router.push(current.route); // Redirige a la ruta correspondiente
                                }, (dismiss) => {
                                    if (dismiss === 'cancel') {
                                        currentIndex++; // Avanza al siguiente paso
                                        askRoute(); // Llama recursivamente para mostrar la siguiente pregunta
                                    } else {
                                        swal({
                                            title: 'Cancelado',
                                            text: 'El analista no ha continuado',
                                            type: 'error',
                                            confirmButtonClass: 'btn btn-info btn-fill',
                                            buttonsStyling: false
                                        });
                                    }
                                });
                            } else {
                                vm.$router.push('/asessments/new_asessment/customer/agro/expenses');
                            }
                        }
                        // Llama la función para iniciar el flujo
                        askRoute(); 
                    });
                }
                else {
                    this.showNotificationError('Debe ingresar al menos un inmueble ');
                    // this.$router.push('/asessments/new_asessment/customer/others/additional_information');
                }
            }
        },
        mounted () {
            if (this.$store.state.isCustomer) {
                if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].agroData.estate) {
                    this.products = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].agroData.estate;
                }
            }
            else if (this.$store.state.isSpouse) {
                if (this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].agroData.estate) {
                    this.products = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].agroData.estate;
                }
            }
            else if (this.$store.state.isGuarantor) {
                if (this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].agroData.estate) {
                    this.products = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].agroData.estate;
                }
            }
        }
    }
</script>
<style lang="scss">
// Estilos para poder centrar el título de el usuario
    .center-title {
        margin-top: 0;
        margin-bottom: 0;
    }
</style>
